const prefix = 'nxt';
const iconName = 'speakerView';
const width = 160;
const height = 160;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M20 10h120c10 0 10 10 10 10v60c0 10-10 10-10 10H20c-10 0-10-10-10-10V20c0-10 10-10 10-10Z',
  'M20 100h20c10 0 10 10 10 10v20c0 10-10 10-10 10H20c-10 0-10-10-10-10v-20c0-10 10-10 10-10Z',
  'M70 100h20c10 0 10 10 10 10v20c0 10-10 10-10 10H70c-10 0-10-10-10-10v-20c0-10 10-10 10-10Z',
  'M1200 100H140c10 0 10 10 10 10v20c0 10-10 10-10 10h-20c-10 0-10-10-10-10v-20c0-10 10-10 10-10Z',
];
const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtSpeakerView = definition;

export { definition, nxtSpeakerView, prefix, iconName, width, height, ligatures, unicode, svgPathData };
